// @flow
import styled, { type StyledComponent } from 'styled-components'

export default (styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
`: StyledComponent<Object, any, any>)
